import { Toggle } from '@fluentui/react';
import { ReviewContext } from 'components/review/ReviewContextProvider';
import React, { useContext, useEffect, useState } from 'react';
import { AdminContext } from 'Store/Admin';

interface ConfigFieldProps {
  id: string;
  label: string;
  tooltip: string;
  describedBy: string;
}

export const AnimationLoopToggleField: React.FC<ConfigFieldProps> = props => {
  const { state, dispatch } = useContext(AdminContext);
  const reviewContext = useContext(ReviewContext);
  const [checked, setChecked] = useState<boolean>(false);

  useEffect(() => {
    if (state.queueDataState) {
      const animationLoopIsActive = state.queueDataState.uxPreferences.subjectJson.animationLoopIsActive;
      if (animationLoopIsActive !== undefined) {
        setChecked(animationLoopIsActive);
      }
    }
  }, [state.queueDataState]);

  const toggleAnimationOnChange = (ev, checked?: boolean) => {
    if (checked !== undefined) {
      setChecked(checked);

      dispatch({
        type: 'TOGGLE_ANIMATION_LOOP',
        payload: checked
      });

      dispatch({
        type: 'IS_UPDATED',
        payload: true
      });

      checked
        ? reviewContext.dispatch({ type: 'ENABLE_CAROUSEL_ANIMATION' })
        : reviewContext.dispatch({ type: 'DISABLE_CAROUSEL_ANIMATION' });
    }
  };

  return (
    <Toggle
      label={`Animation enabled`}
      aria-describedby={props.describedBy}
      checked={checked}
      onText={`On`}
      offText={`Off`}
      onChange={toggleAnimationOnChange}
    />
  );
};
